module.exports = __webpack_public_path__ + "static/media/xueshengzheng.7ec474c0.png";